import { Component, OnInit, Input, Output, ViewChild } from '@angular/core';
import { EventEmitter } from '@angular/common/src/facade/async';
import { OnDemandDriversService } from '../../on-demand-drivers.service';
import { T2CardComponent } from '../../../../trip2-theme/components/t2-card/t2-card.component';

@Component({
  selector: 'app-on-demand-drivers-delete',
  templateUrl: './delete.component.html',
  styleUrls: ['./delete.component.scss']
})
export class DeleteComponent implements OnInit {

  @Input() driverSelected: number;
  @Input() enabledDeleteBtn: boolean;
  @Output() errorMessage: EventEmitter < string > = new EventEmitter < string > ();
  @Output() notify: EventEmitter < boolean > = new EventEmitter < boolean > ();
  @ViewChild('onDemandDriversDeleteModal') modal: T2CardComponent;

  constructor(protected service: OnDemandDriversService) {

  }
  ngOnInit() {}

  /**
   * @name deleteAction
   * @description
   */
  deleteAction(): void {
    if (this.driverSelected === 0) {
      this.errorMessage.emit('Please, select a row');
    } else {
      this.modal.open();
    }
  }

  /**
   * @name
   * @description
   */
  saveAction(): void {
    this.modal.viewProgressBar(true);
    this.service
      .deleteData(this.driverSelected)
      .finally(() => this.modal.viewProgressBar(false))
      .subscribe(
        data => {
          this.sendNotify(data);
          this.modal.close();
        },
        (error) => {
        }
    );
  }

  /**
   * @name
   * @description
   * @param data
   */
  sendNotify(data: any) {
    this.notify.emit(data);
  }

  /**
   * @name open
   * @description Abrir la modal
   */
  open() {
    this.modal.open();
  }

  /**
   * @name close
   * @description Cerrar la modal
   */
  close() {
    this.modal.close();
  }
}



// WEBPACK FOOTER //
// ./src/app/pages/on-demand-drivers/components/delete/delete.component.ts